<template>
  <div>
    <vm-table
        ref="vmTable"
        :filter.sync="filter"
        url="scrapRegistrations/page"
        show-export>
      <template v-if="insertAuth" #toolbar>
        <el-button type="primary" @click="$refs.editPage.open()">新建</el-button>
        <el-button type="success" :loading="exportLoading" @click="partExport">部件导出</el-button>
      </template>
      <template #adSearch>
        <vm-search label="单据编号">
          <el-input v-model.trim="filter.billNo" placeholder="请输入" clearable/>
        </vm-search>
        <vm-search label="维修登记编号">
          <el-input v-model.trim="filter.repairRegistrationNo" placeholder="请输入" clearable/>
        </vm-search>
        <vm-search label="维修类型">
          <el-select v-model="filter.afterSaleType" placeholder="请选择" clearable>
            <el-option value="更换"/>
            <el-option value="维修"/>
            <el-option value="回采"/>
            <el-option value="批量整改"/>
          </el-select>
        </vm-search>
        <vm-search label="售后单号">
          <el-input v-model.trim="filter.afterSaleOrderNo" placeholder="请输入" clearable/>
        </vm-search>
        <vm-search label="质量异常单号">
          <el-input v-model.trim="filter.qualityRegistrationNo" placeholder="请输入" clearable/>
        </vm-search>
        <vm-search label="销售订单号">
          <el-input v-model.trim="filter.salesOrderNo" placeholder="请输入" clearable/>
        </vm-search>
        <vm-search label="事业部">
          <el-select v-model="filter.department" placeholder="请选择" clearable>
            <el-option value="电气"/>
            <el-option value="电机"/>
            <el-option value="运控"/>
            <el-option value="机器人"/>
            <el-option value="杭州之山"/>
            <el-option value="其他"/>
          </el-select>
        </vm-search>
        <vm-search label="需求节点">
          <el-select v-model="filter.demandNode" placeholder="请选择" clearable>
            <el-option value="售后"/>
            <el-option value="生产"/>
            <el-option value="拆解部件"/>
            <el-option value="OEM厂内组装"/>
            <el-option value="OEM厂内负载"/>
            <el-option value="OEM厂内包装"/>
            <el-option value="OEM厂内物流"/>
            <el-option value="OEM厂内SMT"/>
            <el-option value="外协工厂"/>
            <el-option value="研发"/>
          </el-select>
        </vm-search>
        <vm-search label="部件类型">
          <el-select v-model="filter.partType" placeholder="请选择" clearable>
            <el-option value="整机"/>
            <el-option value="板卡"/>
            <el-option value="抱闸电源"/>
            <el-option value="操作器"/>
            <el-option value="IGBT模块"/>
            <el-option value="电容"/>
            <el-option value="电流传感器"/>
            <el-option value="线束"/>
            <el-option value="电子元件"/>
            <el-option value="其它器件"/>
            <el-option value="其它"/>
          </el-select>
        </vm-search>
        <vm-search label="序列号" :value-width="140">
          <el-input
              v-model="filter.serialNos"
              placeholder="支持输入多行"
              type="textarea"
              :rows="1"
              clearable/>
        </vm-search>
        <vm-search label="物料号">
          <el-input v-model="filter.materialNo" placeholder="请输入" clearable/>
        </vm-search>
        <vm-search label="报废类型" :value-width="130">
          <el-select v-model="filter.scrapType" placeholder="请选择" clearable>
            <el-option value="深入检测后无法修复"/>
            <el-option value="版本过低不再使用"/>
            <el-option value="直观判断无法修复"/>
            <el-option value="拆解利用"/>
          </el-select>
        </vm-search>
        <vm-search label="报废库位">
          <el-select v-model="filter.warehouseLocation" placeholder="请选择" clearable>
            <el-option value="2201"/>
            <el-option value="2205"/>
            <el-option value="无库位"/>
          </el-select>
        </vm-search>
        <vm-search label="创建人">
          <el-input v-model.trim="filter.createName" placeholder="请输入" clearable/>
        </vm-search>
        <vm-search-date
            label="创建时间"
            :start-time.sync="filter.createTimeStart"
            :end-time.sync="filter.createTimeEnd"/>
      </template>
      <el-table-column prop="billNo" label="单据编号" align="center" width="100">
        <template #header>
          <el-input v-model.trim="filter.billNo" placeholder="单据编号" clearable @change="$refs.vmTable.handleSearchClick()"/>
        </template>
      </el-table-column>
      <el-table-column
          prop="repairRegistrationNo"
          label="维修登记编号"
          align="center"
          width="100"
          show-overflow-tooltip>
        <template #header>
          <el-input v-model.trim="filter.repairRegistrationNo" placeholder="维修登记编号" clearable @change="$refs.vmTable.handleSearchClick()"/>
        </template>
      </el-table-column>
      <el-table-column prop="afterSaleType" label="维修类型" align="center" width="100">
        <template #header>
          <el-select v-model="filter.afterSaleType" placeholder="维修类型" clearable @change="$refs.vmTable.handleSearchClick()">
            <el-option value="更换"/>
            <el-option value="维修"/>
            <el-option value="回采"/>
            <el-option value="批量整改"/>
          </el-select>
        </template>
      </el-table-column>
      <el-table-column
          prop="afterSaleOrderNo"
          label="售后单号"
          align="center"
          width="100"
          show-overflow-tooltip>
        <template #header>
          <el-input v-model.trim="filter.afterSaleOrderNo" placeholder="售后单号" clearable @change="$refs.vmTable.handleSearchClick()"/>
        </template>
      </el-table-column>
      <el-table-column
          prop="qualityRegistrationNo"
          label="质量异常单号"
          align="center"
          width="110"
          show-overflow-tooltip>
        <template #header>
          <el-input v-model.trim="filter.qualityRegistrationNo" placeholder="质量异常单号" clearable @change="$refs.vmTable.handleSearchClick()"/>
        </template>
      </el-table-column>
      <el-table-column
          prop="salesOrderNo"
          label="销售订单号"
          align="center"
          width="100"
          show-overflow-tooltip>
        <template #header>
          <el-input v-model.trim="filter.salesOrderNo" placeholder="销售订单号" clearable @change="$refs.vmTable.handleSearchClick()"/>
        </template>
      </el-table-column>
      <el-table-column prop="department" label="事业部" align="center" width="100">
        <template #header>
          <el-select
              v-model="filter.department"
              placeholder="事业部"
              clearable
              @change="$refs.vmTable.handleSearchClick()">
            <el-option value="电气"/>
            <el-option value="电机"/>
            <el-option value="运控"/>
            <el-option value="机器人"/>
            <el-option value="杭州之山"/>
            <el-option value="其他"/>
          </el-select>
        </template>
      </el-table-column>
      <el-table-column
          prop="demandNode"
          label="需求节点"
          align="center"
          width="110px"
          show-overflow-tooltip>
        <template #header>
          <el-select
              v-model="filter.demandNode"
              placeholder="需求节点"
              clearable
              @change="$refs.vmTable.handleSearchClick()">
            <el-option value="售后"/>
            <el-option value="生产"/>
            <el-option value="拆解部件"/>
            <el-option value="OEM厂内组装"/>
            <el-option value="OEM厂内负载"/>
            <el-option value="OEM厂内包装"/>
            <el-option value="OEM厂内物流"/>
            <el-option value="OEM厂内SMT"/>
            <el-option value="外协工厂"/>
            <el-option value="研发"/>
          </el-select>
        </template>
      </el-table-column>
      <el-table-column prop="partType" label="部件类型" align="center" width="100">
        <template #header>
          <el-select
              v-model="filter.partType"
              placeholder="部件类型"
              clearable
              @change="$refs.vmTable.handleSearchClick()">
            <el-option value="整机"/>
            <el-option value="板卡"/>
            <el-option value="抱闸电源"/>
            <el-option value="操作器"/>
            <el-option value="IGBT模块"/>
            <el-option value="电容"/>
            <el-option value="电流传感器"/>
            <el-option value="线束"/>
            <el-option value="电子元件"/>
            <el-option value="其它器件"/>
            <el-option value="其它"/>
          </el-select>
        </template>
      </el-table-column>
      <el-table-column
          prop="serialNo"
          label="序列号"
          align="center"
          width="140"
          show-overflow-tooltip>
        <template #header>
          <el-input v-model.trim="filter.serialNo" placeholder="序列号" clearable @change="$refs.vmTable.handleSearchClick()"/>
        </template>
      </el-table-column>
      <el-table-column prop="materialNo" label="物料号" align="center" width="100">
        <template #header>
          <el-input v-model.trim="filter.materialNo" placeholder="物料号" clearable @change="$refs.vmTable.handleSearchClick()"/>
        </template>
      </el-table-column>
      <el-table-column prop="materialName" label="物料描述" min-width="150" show-overflow-tooltip/>
      <el-table-column prop="quantity" label="报废数量" width="80" align="center"/>
      <el-table-column
          prop="scrapType"
          label="报废类型"
          align="center"
          width="130"
          show-overflow-tooltip>
        <template #header>
          <el-select
              v-model="filter.scrapType"
              placeholder="报废类型"
              clearable
              @change="$refs.vmTable.handleSearchClick()">
            <el-option value="深入检测后无法修复"/>
            <el-option value="版本过低不再使用"/>
            <el-option value="直观判断无法修复"/>
            <el-option value="拆解利用"/>
          </el-select>
        </template>
      </el-table-column>
      <el-table-column
          prop="scrapReason"
          label="报废原因"
          width="150"
          align="center"
          show-overflow-tooltip/>
      <el-table-column prop="warehouseLocation" label="报废库位" width="90" align="center">
        <template #header>
          <el-select v-model="filter.warehouseLocation" placeholder="报废库位" clearable @change="$refs.vmTable.handleSearchClick()">
            <el-option value="2201"/>
            <el-option value="2205"/>
            <el-option value="无库位"/>
          </el-select>
        </template>
      </el-table-column>
      <el-table-column prop="note" label="备注" width="100" show-overflow-tooltip/>
      <el-table-column
          prop="createName"
          label="创建人"
          width="90"
          align="center"
          show-overflow-tooltip>
        <template #header>
          <el-input v-model.trim="filter.createName" placeholder="创建人" clearable @change="$refs.vmTable.handleSearchClick()"/>
        </template>
      </el-table-column>
      <el-table-column prop="createTime" label="创建时间" align="center" width="135">
        <template #header>
          <el-date-picker
              v-model="filter.createTime"
              type="date"
              placeholder="创建时间"
              value-format="yyyy-MM-dd"
              @change="$refs.vmTable.handleSearchClick()"/>
        </template>
      </el-table-column>
      <el-table-column
          v-if="editAuth || deleteAuth"
          label="操作"
          align="center"
          fixed="right"
          width="110px">
        <template v-slot="scope">
          <el-button v-if="editAuth" type="success" @click="$refs.editPage.open(scope.row)">编辑</el-button>
          <el-button v-if="deleteAuth" type="danger" @click="handleDelete(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </vm-table>
    <scrap-registration-edit ref="editPage" @save-success="getList(-1)"/>
  </div>
</template>

<script>
  import VmSearchDate from "@/components/VmSearchDate.vue";
  import VmTable from "@/components/v2/VmTable.vue";
  import VmSearch from "@/components/v2/VmSearch.vue";
  import ScrapRegistrationEdit from "@/views/maintenanceManage/ScrapRegistration/ScrapRegistrationEdit.vue";

  export default {
    name: "ScrapRegistrationList",
    components: {ScrapRegistrationEdit, VmSearchDate, VmTable, VmSearch},
    data() {
      return {
        editAuth: true,
        insertAuth: true,
        deleteAuth: true,
        exportLoading: false,
        filter: {
          billNo: "",
          repairRegistrationNo: "",
          afterSaleType: "",
          afterSaleOrderNo: "",
          qualityRegistrationNo: "",
          salesOrderNo: "",
          department: "",
          demandNode: "",
          partType: "",
          serialNo: "",
          serialNos: "",
          materialNo: "",
          scrapType: "",
          warehouseLocation: "",
          createName: "",
          createTime: "",
          createTimeStart: "",
          createTimeEnd: "",
        },
      };
    },
    mounted() {
      this.getList();
    },
    methods: {
      getList(pageNum) {
        this.$refs.vmTable.getList(pageNum);
      },
      handleDelete(row) {
        this.$confirm(`确定删除单据 ${row.billNo} 吗?`, "提示", {type: "warning"}).then(() => {
          this.$http.delete("basic", "scrapRegistrations", row.id).then(() => {
            this.getList(-1);
            this.$message.success("删除成功");
          });
        });
      },
      partExport() {
        this.$confirm("确定导出吗?", "提示", {type: "warning"}).then(() => {
          this.exportLoading = true;
          this.$http.exportExcelByHeader("basic", "scrapRegistrations/part/export", this.filter, "post")
            .finally(() => {
              this.exportLoading = false;
            });
        });
      },
    },
  };
</script>


<style scoped lang="scss">

</style>
